import http from "../http-common";

class InspectionsService {
    createInspection(data) {
      return http.post("inspection/create", data);
    }
    updateInspection(data) {
      return http.post("inspection/update", data);
    }
    getInspections(data) {
      return http.get("inspection/list", { params: data });
    }
    deleteInspection(data) {
      return http.delete("inspection/delete", { params: data });
    }
    updateInspectionStatus(data) {
      return http.post("inspection/status/update",  data);
    }
    getInspectionDetail(data) {
      return http.get("inspection/detail", { params: data });
    }
    getInspectionData(data) {
      return http.get("inspection/data", { params: data });
    }
}

export default new InspectionsService();